import { React, useEffect, useState } from "react";
import NavBarTop from "../Reusable_Components/NavBarTop";
import { ACLS, COMMERCIAL_HEAD_GROUP, countryCodes, FINANCE_MANAGER_GROUP, PORTOS_CUSTOMER_GROUP, RECORDS_PER_PAGE } from "../../Config";
import TableComponent from "../Reusable_Components/TableComponent";
import { CEO_GROUP, } from "../../Config";
import { Button, Modal, Spinner, Tab, Tabs } from "react-bootstrap";
import axios from "axios";
import { base_url } from "../../utilities";
import AlertPopUp from "../Reusable_Components/Alert";
import { useNavigate } from "react-router-dom";
import { checkUniqueness, eleminateSpacesAtStartOfInputField, encrypt, processAndValidateEmail, validateGstNumber, validateValue } from "../Reusable_Components/ReusableFunctions";
import PhoneInput from "react-phone-input-2";
import { addUser } from "../../Redux/Actions/Actions";
import { useDispatch } from "react-redux";
import FormLoader from "../Reusable_Components/FromLoader";
import Footer from "../Login/Footer";
import { MdPersonAddAlt1 } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import Pagination from "../Reusable_Components/Pagination";
import { GoSearch } from "react-icons/go";
import LeftNavBar from "../Reusable_Components/LeftNavBar";



export default function Customers() {
    const dispatch = useDispatch()

    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("1");

    const [viewClicked, setViewClicked] = useState(false);
    const [editClicked, setEditClicked] = useState(false);


    const [isLoading, setIsLoading] = useState(false);


    //States For Company Details
    const [contactName, setContactName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [gstNumber, setGstNumber] = useState('');
    const [cinNumber, setCinNumber] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [panName, setPanName] = useState('');
    const [hcnNumber, setHcnNumber] = useState('');
    const [customerIdForReference, setCustomerIdForReference] = useState('');
    //States For Registered Address
    const [registeredAddId, setRegisteredAddId] = useState('');
    const [registeredStateProvince, setRegisteredStateProvince] = useState('');
    const [registeredPostalCode, setRegisteredPostalCode] = useState('');
    const [registeredStreetAddress, setRegisteredStreetAddress] = useState('');
    const [registeredStreetAddressLane2, setRegisteredStreetAddressLane2] = useState('');
    const [registeredCity, setRegisteredCity] = useState('');
    const [registeredCountry, setRegisteredCountry] = useState('');
    const [doorNumber, setDoorNumber] = useState('');
    const [panNumber, setPanNumber] = useState('');
    //States For Billing Address
    const [billingAddId, setBillingAddId] = useState('');
    const [billingStateProvince, setBillingStateProvince] = useState('');
    const [billingPostalCode, setBillingPostalCode] = useState('');
    const [billingStreetAddress, setBillingStreetAddress] = useState('');
    const [billingStreetAddressLane2, setBillingStreetAddressLane2] = useState('');
    const [billingCity, setBillingCity] = useState('');
    //States For Shipping Address
    const [shippingAddId, setShippingAddId] = useState('');
    const [shippingStateProvince, setShippingStateProvince] = useState('');
    const [shippingPostalCode, setShippingPostalCode] = useState('');
    const [shippingStreetAddress, setShippingStreetAddress] = useState('');
    const [shippingStreetAddressLane2, setShippingStreetAddressLane2] = useState('');
    const [shippingCity, setShippingCity] = useState('');

    //States For Modal
    const [alertShow, setAlertShow] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [alertValue, setAlertValue] = useState('');
    const [alertButtons, setAlertButtons] = useState([]);
    const [errorValue, setErrorValue] = useState('');



    //contact person details
    const [primaryContactName, setPrimaryContactName] = useState('');
    const [primaryContactEmail, setPrimaryContactEmail] = useState('');
    const [primaryContactPhone, setPrimaryContactPhone] = useState('');

    //gst change history
    

    const [changedHistory, setChangedHistory] = useState([]);
    const [previousRecords, setPreviousRecords] = useState([]);

    const [changedHistoryForTable, setChangedHistoryForTable] = useState([]);

    useEffect(() => {
        if(changedHistory){
            const historyTableData = changedHistory.map(item => ({
                ...item,
                registered_address: item.registered_address ? [
                    item.registered_address.door_number,
                    item.registered_address.street_address_1,
                    item.registered_address.street_address_2,
                    item.registered_address.city,
                    item.registered_address.state,
                    item.registered_address.postal_code,
                    item.registered_address.country
                ].join(','): '',
                
            }))
            setChangedHistoryForTable(historyTableData);
        }
    }, [changedHistory]);

    const getChangedHistory = () => {
        setIsLoading(true);
        axios.get(base_url + "customers/customers_jn",{
            params: { filter_condition: JSON.stringify({ action:"U", gst_number:gstNumber }) }
        })
        .then((response) => {
            if (response?.data?.data[0] === 'error') {
                setIsLoading(false);
                setErrorValue(response?.data?.data[1].message)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(response?.data?.data[1].message)
                setAlertButtons([
                    { name: 'Close', action: () => { setAlertShow(false) } },
                ])
            }
            else {
                setIsLoading(false);
                const details = response?.data?.data
                setChangedHistory(details);
            }
        })
        .catch((error) => {
            setIsLoading(false);
            setErrorValue(error?.response?.data.message)
            setAlertShow(true)
            setAlertType('error')
            setAlertMessage('Error')
            setAlertValue(error?.response?.data.message)
            setAlertButtons([
                { name: 'Close', action: () => { setAlertShow(false) } },
            ])
        });
    }

    const [addNewCustomerClicked, setAddNewCustomerClicked] = useState(false);
    const [gstPreviousModalClicked, setGstPreviousModalClicked] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');



    const [listOfContacts, setListOfContacts] = useState([])

    const formatContactsForTable = (contracts) => {
        const contactsTableData = [];

        contracts?.forEach(contract => {
            // Add primary contact for this contract
            if (
                contract?.primary_contact_name ||
                contract?.primary_contact_email ||
                contract?.primary_contact_phone_number
            ) {
                contactsTableData.push({
                    contract_number: contract.contract_number ,
                    contract_name: contract.contract_name ,
                    contact_type: "Primary",
                    name: contract.primary_contact_name ,
                    email: contract.primary_contact_email ,
                    phone_number: contract.primary_contact_phone_number ,
                });
            }

            // Add secondary contacts for this contract
            if (Array.isArray(contract.contacts)) {
                contract.contacts.forEach(contact => {
                    contactsTableData.push({
                        contract_number: contract.contract_number ,
                        contract_name: contract.contract_name ,
                        contact_type: "Secondary", 
                        name: contact.name ,
                        email: contact.email ,
                        phone_number: contact.phone_number ,
                    });
                });
            }
        });

        return contactsTableData;
    };

    //pagination
    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(1);
    const handledPaginationNextClicked = () => {
        // Logic for handling next page click
        setPage(prev => prev + 1);
    };
    const handledPaginationPrevClicked = () => {
        // Logic for handling previous page click
        setPage(prev => prev - 1);
    }

    const backFunction = () => {
        setCurrentPage(1);
        setViewClicked(false);
        setEditClicked(false);
        setGstNumber('');
        setContactName('');
        setPhoneNumber('');
        setEmail('');
        setCinNumber('');
        setCompanyName('');
        setPanName('');
        setHcnNumber('');
        setRegisteredAddId('');
        setRegisteredStateProvince('');
        setRegisteredPostalCode('');
        setRegisteredStreetAddress('');
        setRegisteredStreetAddressLane2('');
        setRegisteredCity('');
        setRegisteredCountry('');
        setBillingAddId('');
        setBillingStateProvince('');
        setBillingPostalCode('');
        setBillingStreetAddress('');
        setBillingStreetAddressLane2('');
        setBillingCity('');
        setShippingAddId('');
        setShippingStateProvince('');
        setShippingPostalCode('');
        setShippingStreetAddress('');
        setShippingStreetAddressLane2('');
        setShippingCity('');
        setIsValidGstNumber(true);
        setErrorValue('');
        setActiveTab("1");
        setCustomerUsersList([]);
        setGstDetailsChanged(false);
        setPrimaryContactName('');
        setPrimaryContactEmail('');
        setPrimaryContactPhone('');
        setPanNumber('');
        setPage(1);
        setAddNewCustomerClicked(false);

    }

    //gst 
    const [gstLoader, setGstLoader] = useState(false);
    const GstLoader = () => {
        return <Spinner style={{ height: "18px", width: "18px" }} animation="border" variant="light" />
    }


    //gst details update
    const [existingGstDetails, setExistingGstDetails] = useState({
        gstNumber: '',
        companyName: '',
        panName: '',
        registeredPostalCode: '',
        registeredStreetAddress: '',
        registeredStreetAddressLane2: '',
        registeredCity: '',
        registeredStateProvince: '',
        registeredCountry: '',
    });
    const [gstDetailsChanged, setGstDetailsChanged] = useState(false);

    const handleUpdateGstDetails = (gstNumber) => {
        setIsLoading(true);
        if (gstDetailsChanged) {
            setIsLoading(true);
            axios.put(base_url + "customers/customerDetails", { gst_number: gstNumber })
                .then((response) => {
                    if (response?.data?.data[0] === 'error') {
                        setErrorValue(response?.data?.data[1].message)
                        setAlertShow(true)
                        setAlertType('error')
                        setAlertMessage('Error')
                        setAlertValue(response?.data?.data[1].message)
                        setAlertButtons([
                            { name: 'Close', action: () => { setAlertShow(false) } },
                        ])
                        setIsLoading(false)

                    }
                    else {
                        const details = response.data.data
                        setCompanyName(details?.company_name)
                        setPanName(details?.pan_number)
                        setRegisteredStateProvince(details?.registered_address?.state)
                        setRegisteredPostalCode(details?.registered_address?.postal_code)
                        setRegisteredStreetAddress(details?.registered_address?.door_number + ", " + details?.registered_address?.street_address_1)
                        setRegisteredStreetAddressLane2(details?.registered_address?.street_address_2)
                        setRegisteredCity(details?.registered_address?.city)
                        setRegisteredCountry(details?.registered_address?.country)

                        setBillingStateProvince(details?.registered_address?.state);
                        // setBillingCountry(details?.registered_address?.country);
                        // setBillingPostalCode(details?.registered_address?.postal_code);
                        setShippingStateProvince(details?.registered_address?.state);
                        // setShippingCountry(details?.registered_address?.country);
                        setExistingGstDetails({
                            gstNumber: details?.gst_number,
                            companyName: details?.company_name,
                            panName: details?.pan_number,
                            registeredPostalCode: details?.registered_address?.postal_code,
                            registeredStreetAddress: details?.registered_address?.door_number + ", " + details?.registered_address?.street_address_1,
                            registeredStreetAddressLane2: details?.registered_address?.street_address_2,
                            registeredCity: details?.registered_address?.city,
                            registeredStateProvince: details?.registered_address?.state,
                            registeredCountry: details?.registered_address?.country
                        });
                        setGstDetailsChanged(false);
                        setAlertShow(true);
                        setAlertType('success');
                        setAlertMessage('Success');
                        setAlertValue('GST details have been updated successfully.');
                        setAlertButtons([
                            {
                                name: 'Close',
                                action: () => {
                                    setAlertShow(false);
                                }
                            }
                        ]);
                        setIsLoading(false);
                    }
                })
                .catch((error) => {

                    setAlertShow(true);
                    setAlertType('error');
                    setAlertValue(error?.response?.data.message);
                    setAlertMessage('Error');
                    setAlertButtons([
                        {
                            name: 'Close',
                            action: () => {
                                setAlertShow(false);
                            }
                        }
                    ]);
                    setIsLoading(false);
                    setGstLoader(false);
                });
        }
    }


    const handleGstClick = (gstId) => {
        setGstLoader(true)
        axios.get(base_url + "gstPortal/verifyGstin?gst_number=" + gstId)
            .then((response) => {
                if (response?.data?.data[0] === 'error') {
                    setErrorValue(response?.data?.data[1].message)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(response?.data?.data[1].message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                    setIsLoading(false)
                    setGstLoader(false);
                }
                else {
                    const details = response.data.data
                    setCompanyName(details?.company_name)
                    setPanName(details?.pan_number)
                    setRegisteredStateProvince(details?.registered_address?.state)
                    setRegisteredPostalCode(details?.registered_address?.postal_code)
                    setRegisteredStreetAddress(details?.registered_address?.door_number + ", " + details?.registered_address?.street_address_1)
                    setRegisteredStreetAddressLane2(details?.registered_address?.street_address_2)
                    setRegisteredCity(details?.registered_address?.city)
                    setRegisteredCountry(details?.registered_address?.country)
                    setPanNumber(details?.pan_number)

                    setRegisteredStateProvince(details?.registered_address?.state);
                    setRegisteredCountry(details?.registered_address?.country);
                    // setBillingPostalCode(details?.registered_address?.postal_code);
                    setShippingStateProvince(details?.registered_address?.state);
                    // setShippingCountry(details?.registered_address?.country);
                    // setShippingPostalCode(details?.registered_address?.postal_code);
                    const changed = details?.gst_number !== existingGstDetails.gstNumber || details?.company_name !== existingGstDetails.companyName || details?.pan_number !== existingGstDetails.panName || details?.registered_address?.postal_code?.toString() !== existingGstDetails.registeredPostalCode?.toString() || (details?.registered_address?.door_number + ", " + details?.registered_address?.street_address_1) !== existingGstDetails.registeredStreetAddress || details?.registered_address?.street_address_2 !== existingGstDetails.registeredStreetAddressLane2 || details?.registered_address?.city !== existingGstDetails.registeredCity || details?.registered_address?.state !== existingGstDetails.registeredStateProvince || details?.registered_address?.country !== existingGstDetails.registeredCountry
                    setGstDetailsChanged(changed);
                    setGstLoader(false)
                    setIsLoading(false);
                }
            })
            .catch((error) => {
                const errorDetails = JSON.parse(error.response.data.error_logs.status_desc);
                const errorMessage = errorDetails[0].ErrorMessage
                setErrorValue(errorMessage);
                setAlertShow(true);
                setAlertType('error');
                setAlertMessage('Error');
                setAlertValue(errorMessage);
                setAlertButtons([
                    {
                        name: 'Close',
                        action: () => {
                            setAlertShow(false);
                        }
                    }
                ]);
                setIsLoading(false);
                setGstLoader(false);
            });
    }


    useEffect(() => {
        if (currentPage === 1) {
            getAllCustomers()
        }
        if(currentPage == 2){
            getChangedHistory();
        }
    }, [currentPage, page])


    useEffect(() => {
        setGstDetailsChanged(false)
    }, [viewClicked, editClicked, currentPage])

    //states for users
    const [customerUsersList, setCustomerUsersList] = useState([])


    // Get all customers for table
    const [customerList, setCustomerList] = useState([])
    const [contractsList, setContractsList] = useState([])

    const applyFilter = () => {
        setPage(1);
        getAllCustomers();
    }

    const handleClearFilters = () => {
        setSearchTerm("");
        backFunction();
        setIsLoading(true);
        let data = {
            page_number: page,
            items_per_page: RECORDS_PER_PAGE,
            search_text: "",
        }
        axios.get(base_url + "customers", { params: data })
            .then((res) => {
                if (res?.data?.data[0] === 'error') {
                    setIsLoading(false);
                    setErrorValue(res?.data?.data[1].message)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(res?.data?.data[1].message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                }
                else {
                    setIsLoading(false);
                    const data = res?.data?.data
                    setCustomerList(data)
                    setTotalRecords(res?.data?.info?.total_no_of_records)
                }
            })
            .catch((err) => {
                setIsLoading(false);
                setErrorValue(err?.response?.data.message)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(err?.response?.data.message)
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                        }
                    },
                ])
            })
    }

    const getAllCustomers = () => {
        setIsLoading(true);
        let data = {
            page_number: page,
            items_per_page: RECORDS_PER_PAGE,
            search_text: searchTerm,
        }
        axios.get(base_url + "customers", { params: data })
            .then((res) => {
                if (res?.data?.data[0] === 'error') {
                    setIsLoading(false);
                    setErrorValue(res?.data?.data[1].message)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(res?.data?.data[1].message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                }
                else {
                    setIsLoading(false);
                    const data = res?.data?.data
                    setCustomerList(data)
                    setTotalRecords(res?.data?.info?.total_no_of_records)
                }
            })
            .catch((err) => {
                setIsLoading(false);
                setErrorValue(err?.response?.data.message)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(err?.response?.data.message)
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                        }
                    },
                ])
            })
    }


    const [isValidGstNumber, setIsValidGstNumber] = useState(true);


    const handleKeyPressForGst = (e) => {
        const allowedKeys = [
            'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
            'Backspace', 'Delete', 'Tab', 'Enter',
            'Home', 'End', 'PageUp', 'PageDown', 'Escape'
        ];
        if (allowedKeys.includes(e.key)) {
            return;
        }
        const allowedChars = /^[0-9a-zA-Z]$/;
        if (!allowedChars.test(e.key)) {
            e.preventDefault();
        }
    };

    const handleGstNumberChange = (e) => {
        const input = e.target.value;
        const { isValid, uppercasedInput } = validateGstNumber(input);
        setGstNumber(uppercasedInput);
        setIsValidGstNumber(isValid);
    };


    const handleEnable = (data) => {
        return false;
    }



    const handleViewClicked = (data) => {
        setIsLoading(true);
        setViewClicked(true);
        axios.get(base_url + "customers/customerDetails", {
            params: { filter_condition: JSON.stringify({ customer_id: data["customer_id"] }) }
        })
            .then((response) => {
                setIsLoading(false);

                if (response?.data?.data[0] === 'error') {
                    setErrorValue(response?.data?.data[1].message)

                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(response?.data?.data[1].message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                backFunction();
                            }
                        },
                    ])
                    setIsLoading(false)
                }
                else {
                    setIsLoading(false);
                    setCurrentPage(2)
                    const details = response?.data?.data
                    setCustomerIdForReference(details?.customer_id)
                    setContactName(details?.primary_contact_name)
                    setPhoneNumber(details?.primary_contact)
                    setEmail(details?.primary_contact_email)
                    setGstNumber(details?.gst_number)
                    setCinNumber(details?.cin)
                    setHcnNumber(details?.hcn_number)
                    setDoorNumber(details?.registered_address?.door_number)
                    setPanName(details?.pan_number)

                    setPrimaryContactName(details?.primary_contact_name)
                    setPrimaryContactEmail(details?.primary_contact_email)
                    setPrimaryContactPhone(details?.primary_contact_phone_number)
                    setContractsList(details?.contracts)
                    setListOfContacts(formatContactsForTable(details?.contracts));

                    setCustomerUsersList(details?.users)


                    setCompanyName(details?.company_name)
                    setPanName(details?.pan_number)
                    setRegisteredAddId(details?.registered_address?.address_id)
                    setRegisteredStateProvince(details?.registered_address?.state)
                    setRegisteredPostalCode(details?.registered_address?.postal_code)
                    setRegisteredStreetAddress(details?.registered_address?.door_number + ", " + details?.registered_address?.street_address_1)
                    setRegisteredStreetAddressLane2(details?.registered_address?.street_address_2)
                    setRegisteredCity(details?.registered_address?.city)
                    setRegisteredCountry(details?.registered_address?.country)

                    setBillingAddId(details?.billing_address?.address_id)
                    setBillingStateProvince(details?.billing_address?.state);
                    setBillingPostalCode(details?.billing_address?.postal_code);
                    setBillingStreetAddress(details?.billing_address?.street_address_1);
                    setBillingStreetAddressLane2(details?.billing_address?.street_address_2);
                    setBillingCity(details?.billing_address?.city);

                    setShippingAddId(details?.shipping_address?.address_id)
                    setShippingStateProvince(details?.shipping_address?.state);
                    setShippingPostalCode(details?.shipping_address?.postal_code);
                    setShippingStreetAddress(details?.shipping_address?.street_address_1);
                    setShippingStreetAddressLane2(details?.shipping_address?.street_address_2);
                    setShippingCity(details?.shipping_address?.city);
                }
            })
            .catch((error) => {
                setErrorValue(error?.response?.data.message);

                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        backFunction();
                    }
                }])
                setIsLoading(false)
            });
    }


    const handleEditClicked = (data) => {
        setIsLoading(true);
        setEditClicked(true);
        axios.get(base_url + "customers/customerDetails", {
            params: { filter_condition: JSON.stringify({ customer_id: data["customer_id"] }) }
        })
            .then((response) => {
                setIsLoading(false);

                if (response?.data?.data[0] === 'error') {
                    setErrorValue(response?.data?.data[1].message)

                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(response?.data?.data[1].message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                                backFunction();
                            }
                        },
                    ])
                    setIsLoading(false)
                }
                else {
                    setCurrentPage(2);
                    const details = response?.data?.data
                    setCustomerIdForReference(details?.customer_id)
                    setContactName(details?.primary_contact_name)
                    setPhoneNumber(details?.primary_contact)
                    setEmail(details?.primary_contact_email)
                    setGstNumber(details?.gst_number)
                    setCinNumber(details?.cin)
                    setHcnNumber(details?.hcn_number)
                    setDoorNumber(details?.registered_address?.door_number)
                    setPrimaryContactName(details?.primary_contact_name)
                    setPrimaryContactEmail(details?.primary_contact_email)
                    setPrimaryContactPhone(details?.primary_contact_phone_number)
                    setPanNumber(details?.pan_number)
                    setContractsList(details?.contracts)
                    setListOfContacts(formatContactsForTable(details?.contracts));

                    setCustomerUsersList(details?.users)

                    setExistingGstDetails({
                        gstNumber: details?.gst_number,
                        companyName: details?.company_name,
                        panName: details?.pan_number,
                        registeredPostalCode: details?.registered_address?.postal_code,
                        registeredStreetAddress: details?.registered_address?.door_number + ", " + details?.registered_address?.street_address_1,
                        registeredStreetAddressLane2: details?.registered_address?.street_address_2,
                        registeredCity: details?.registered_address?.city,
                        registeredStateProvince: details?.registered_address?.state,
                        registeredCountry: details?.registered_address?.country,
                    });

                    setCompanyName(details?.company_name)
                    setPanName(details?.pan_number)
                    setRegisteredAddId(details?.registered_address?.address_id)
                    setRegisteredStateProvince(details?.registered_address?.state)
                    setRegisteredPostalCode(details?.registered_address?.postal_code)
                    setRegisteredStreetAddress(details?.registered_address?.door_number + ", " + details?.registered_address?.street_address_1)
                    setRegisteredStreetAddressLane2(details?.registered_address?.street_address_2)
                    setRegisteredCity(details?.registered_address?.city)
                    setRegisteredCountry(details?.registered_address?.country)

                    setBillingAddId(details?.billing_address?.address_id)
                    setBillingStateProvince(details?.billing_address?.state);
                    setBillingPostalCode(details?.billing_address?.postal_code);
                    setBillingStreetAddress(details?.billing_address?.street_address_1);
                    setBillingStreetAddressLane2(details?.billing_address?.street_address_2);
                    setBillingCity(details?.billing_address?.city);

                    setShippingAddId(details?.shipping_address?.address_id)
                    setShippingStateProvince(details?.shipping_address?.state);
                    setShippingPostalCode(details?.shipping_address?.postal_code);
                    setShippingStreetAddress(details?.shipping_address?.street_address_1);
                    setShippingStreetAddressLane2(details?.shipping_address?.street_address_2);
                    setShippingCity(details?.shipping_address?.city);

                }
            })
            .catch((error) => {
                setErrorValue(error?.response?.data.message);

                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        backFunction();
                    }
                }])
                setIsLoading(false)
            });
    }



    const handleSaveClicked = () => {
        setIsLoading(true);
        axios.post(base_url + "customers", {
            gst_number: gstNumber,
        })
            .then((response) => {
                if (response?.data?.data[0] === 'error') {
                    setIsLoading(false);
                    setErrorValue(response?.data?.data[1].message)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(response?.data?.data[1].message)
                    setAlertButtons([
                        { name: 'Close', action: () => { setAlertShow(false) } },
                    ])
                } else {
                    setIsLoading(false);
                    setAlertShow(true)
                    setAlertType('success')
                    setAlertMessage('Success')
                    setAlertValue('Customer has been added successfully.')
                    setAlertButtons([
                        { name: 'Close', action: () => { setAlertShow(false) } },
                    ])
                    backFunction();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setErrorValue(error?.response?.data.message)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([
                    { name: 'Close', action: () => { setAlertShow(false) } },
                ])
            });

    }

    const handleClose = () => {
        setAlertShow(true);
        setAlertType('warning');
        setAlertMessage('Are you sure you want to close?');
        setAlertValue('All unsaved data will be lost.');
        setAlertButtons([{
            name: 'Close', action: () => {
                setAlertShow(false)
            }
        }, {
            name: 'Proceed', action: () => {
                setAlertShow(false)
                backFunction()
            }
        }])
    }

    const getGroupNameOriginal = (val) => {
        switch (val) {
            case "CEO":
                return CEO_GROUP;
            case "Finance Manager":
                return FINANCE_MANAGER_GROUP;
            case "Commercial Head":
                return COMMERCIAL_HEAD_GROUP;
                
            default:
                return "";
        }
    }

    const isManage = ACLS[getGroupNameOriginal(localStorage.getItem('group'))].find(obj => obj.ROUTE === "/customers" && obj.PERMISSIONS?.includes("MANAGE"));


    const handleSearchSubmit = (searchValue) => {
        if (validateValue(searchValue)) {
            setSearchTerm(searchValue);
        }
    };

    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />
                <AlertPopUp alertShow={alertShow} alertType={alertType}
                    alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />
            </>
            {gstPreviousModalClicked &&  <Modal keyboard={false} backdrop="static" size='lg' show={gstPreviousModalClicked} onHide={() => setGstPreviousModalClicked(false)} centered className="popper-modal">
                <Modal.Body className="text-center">
                    <h5>Changed History</h5>
                    <div style={{ overflow: "auto" }}>
                        <TableComponent
                            headers={[
                                {
                                    name:"GST Number",
                                    type:"text",
                                    key:"gst_number",
                                },{
                                    name:"PAN Number",
                                    type:"text",
                                    key:"pan_number",
                                },{
                                    name:"Company Name",
                                    type:"text",
                                    key:"company_name",
                                },{
                                    name:"Address",
                                    type:"text",
                                    key:"registered_address",
                                },{
                                    name:"CIN",
                                    type:"text",
                                    key:"cin",
                                },{
                                    name:"Created At",
                                    type:"time_stamp",
                                    key:"created_at",
                                    sort: true
                                },{
                                    name:"Created By",
                                    type:"text",
                                    key:"created_by",
                                    sort: true
                                },{
                                    name:"Created At",
                                    type:"time_stamp",
                                    key:"updated_at",
                                    sort: true
                                },{
                                    name:"Updated By",
                                    type:"text",
                                    key:"updated_by",
                                    sort: true
                                }
                            ]}
                            data={changedHistoryForTable}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center" >
                    <Button variant="secondary" className="secondary" onClick={() => setGstPreviousModalClicked(false)} >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            {currentPage === 1 &&
                <div className='meter_reports_container'>
                    <div className='d-flex justify-content-between align-items-center flex-wrap mb-3'>
                        <div className='d-flex align-items-center gap-3 '>
                            <h3 className="invoice-heading" >Customers</h3>
                        </div>
                        {
                            isManage ?
                                <div className='add-facility-button' onClick={() => {
                                    setCurrentPage(2);
                                    setActiveTab("1");
                                    setAddNewCustomerClicked(true);
                                }}>
                                    <MdPersonAddAlt1 size={20} className='icon-newContact' alt='add new customer' />
                                    <span>Add New Customer</span>
                                </div>
                                :
                                null
                        }
                    </div>
                    <div className='d-flex gap-2 flex-wrap mb-2'>
                        <div className='fin_man_meter_search_bar_container'>
                            <input type='search' placeholder='Search' className='fin_man_meter_search_bar'
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)} />
                            <GoSearch className='fin_man_meter_search_bar_icon' />
                        </div>
                        <button className="add_fac_apply_btn primary-button"
                            // disabled={selectedStateFilter === '' && selectedCityFilter === '' && searchTerm === ''} 

                            onClick={() => {
                                applyFilter()
                            }}>Apply
                        </button>
                        <div className='add_fac_apply_btn secondary-button C-pointer'
                            onClick={handleClearFilters}
                        >
                            <span >Clear</span>
                        </div>
                    </div>
                    <div className='table_container_commercial_head'>
                        <TableComponent
                            headers={[{
                                name: "Company Name",
                                type: "text",
                                key: "company_name",
                                sort: true
                            }, {
                                name: "PAN Number",
                                type: "text",
                                key: "pan_number",
                                sort: true
                            }, {
                                name: "GST Number",
                                type: "text",
                                key: "gst_number",
                                sort: true
                            }, {
                                name: "Created At",
                                type: "time_stamp",
                                key: "created_at",
                                sort: true
                            }, {
                                name: "Updated At",
                                type: "time_stamp",
                                key: "updated_at",
                                sort: true
                            }, {
                                name: "Created By",
                                type: "text",
                                key: "created_by",
                                sort: true
                            }, {
                                name: "Updated By",
                                type: "text",
                                key: "updated_by",
                                sort: true
                            },
                            {
                                name: "Action",
                                type: "button",
                                buttons: isManage ? [{
                                    name: "View",
                                    icon: "./images/icons/ViewViewIconEye.svg",
                                    disable: handleEnable,
                                    action: (data) => handleViewClicked(data)
                                },
                                {
                                    name: "Edit",
                                    icon: "./images/icons/Edit.svg",
                                    disable: handleEnable,
                                    action: (data) => handleEditClicked(data)
                                },

                                ]
                                    :
                                    [{
                                        name: "View",
                                        icon: "./images/icons/ViewViewIconEye.svg",
                                        disable: handleEnable,
                                        action: (data) => handleViewClicked(data)
                                    },

                                    ]
                            }

                            ]}
                            data={customerList}
                        />
                    </div>
                    <div style={{ flex: "0 1 auto" }}>
                        <Pagination
                            handledPaginationNextClicked={handledPaginationNextClicked}
                            handledPaginationPrevClicked={handledPaginationPrevClicked}
                            totalRecords={totalRecords}
                            recordsPerPage={RECORDS_PER_PAGE}
                            currentPaginationPage={page}
                        />
                    </div>

                </div>
            }
            {currentPage === 2 &&
                <div className="newAssetContainer" >
                    <div
                        className="orgProfileContainer"
                    >
                        <div>
                            <h2>Customers
                            </h2>
                        </div>
                        <div className="custom-tabs" style={{ marginTop: "20px" }}>
                            <Tabs
                                activeKey={activeTab}
                                onSelect={(k) => setActiveTab(k)}
                                id="uncontrolled-tab-example"
                                className="mb-0"
                            >
                                <Tab eventKey="1" title="Company Information"
                                    className="assetTabs" >
                                    <div className="infoBody" >
                                        <div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h6 style={{ fontWeight: "bold" }}>Company Details</h6>

                                                {!addNewCustomerClicked && <span style={{ textDecoration: "underline", color: "#007bff", cursor: "pointer" }}
                                                    onClick={() => {
                                                        setGstPreviousModalClicked(true);
                                                        getChangedHistory();
                                                    }
                                                    }
                                                >
                                                    Changed History
                                                </span>}
                                            </div>
                                            <div className="infoBodyInputs">
                                                <div className="responsiveInputSection">
                                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <label className='add-facility-modal-label'>GST Number {<span style={{ color: "red" }}>*</span>}</label>
                                                            <input
                                                                disabled={viewClicked || editClicked}
                                                                value={gstNumber}
                                                                onChange={handleGstNumberChange} onKeyDown={handleKeyPressForGst}
                                                                type='text' className='form-control ' style={{ width: "90%", border: "0.5px solid #9D9D9C", }} />
                                                            {!isValidGstNumber && <span className="input-error-text">Invalid GST number</span>}
                                                        </div>
                                                        {
                                                            !viewClicked ? (
                                                                <div style={{ marginBottom: "0px", display: "flex", alignItems: "start", marginTop: "20px" }}>
                                                                    <div
                                                                        style={{
                                                                            background: "grey",
                                                                            padding: "9px 10px",
                                                                            marginLeft: "-20px",
                                                                            borderRadius: "5px",
                                                                            opacity: gstNumber === '' || !isValidGstNumber ? 0.3 : 1,
                                                                            pointerEvents: gstNumber === '' || !isValidGstNumber ? 'none' : 'auto'
                                                                        }}
                                                                        className="C-pointer"
                                                                        data-toggle={editClicked && "tooltip"} data-placement={editClicked && "top"} title={editClicked && " Refresh to fetch latest GST information and update your GST details"}
                                                                        onClick={() => {
                                                                            if (gstNumber !== '' && isValidGstNumber) {
                                                                                setGstLoader(true);
                                                                                // dispatch(GstNumberDetails(gstNumber))
                                                                                handleGstClick(gstNumber);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {
                                                                            gstLoader && !errorValue ? (
                                                                                <GstLoader />
                                                                            ) : (
                                                                                <FaSearch color="white" size={20} style={{ fontWeight: "bolder" }} />
                                                                            )
                                                                        }
                                                                    </div>
                                                                </div>
                                                            ) : null
                                                        }
                                                    </div>


                                                    <div>
                                                        <label className='add-facility-modal-label'>CIN Number </label>
                                                        <input type='text'
                                                            disabled={viewClicked}
                                                            value={cinNumber}
                                                            onChange={(e) => setCinNumber(e.target.value)}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                </div>
                                                {gstDetailsChanged && editClicked && customerIdForReference ? (
                                                    <div className="d-flex align-items-center gap-2 justify-content-between warning-message" style={{ marginTop: "10px" }}>
                                                        <p style={{ marginBottom: " 0px", color: "orangered" }}>The GST details have been changed but not updated. Please click the update button to update the GST details.</p>
                                                        <button onClick={() => handleUpdateGstDetails(gstNumber)} style={{ height: "30px", padding: "0 12px" }} className="btn btn-secondary">Update</button>
                                                    </div>
                                                ) : null}

                                            </div>
                                        </div>
                                        <hr></hr>

                                        <div>
                                            <h6 style={{ fontWeight: "bold" }}>Registered Address</h6>
                                            <div className="infoBodyInputs">
                                                <div className="responsiveInputSection">
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Company Name {<span style={{ color: "red" }}>*</span>}</label>
                                                        <input type='text'
                                                            disabled={true}
                                                            value={companyName}

                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >PAN {<span style={{ color: "red" }}>*</span>}</label>
                                                        <input type='text'
                                                            disabled={true}
                                                            value={panName}

                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Street Address  </label>
                                                        <input type='text'
                                                            disabled={true}
                                                            value={registeredStreetAddress}
                                                            onChange={(e) => setRegisteredStreetAddress(e.target.value)}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>


                                                </div>
                                                <div className="responsiveInputSection">

                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Street Address Lane 2 </label>
                                                        <input type='text'
                                                            disabled={true}
                                                            value={registeredStreetAddressLane2}
                                                            onChange={(e) => setRegisteredStreetAddressLane2(e.target.value)}
                                                            className='form-control responsive-add-facility-input-fields' />

                                                    </div>
                                                    <div>
                                                        <label className='add-facility-modal-label'>City </label>
                                                        <input type='text'
                                                            disabled={true}
                                                            value={registeredCity}
                                                            onChange={(e) => setRegisteredCity(e.target.value)}
                                                            className='form-control responsive-add-facility-input-fields' />

                                                    </div>
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >State/Province </label>
                                                        <input type='text'
                                                            disabled={true}
                                                            value={registeredStateProvince}
                                                            onChange={(e) => setRegisteredStateProvince(e.target.value)}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>



                                                </div>
                                                <div className="responsiveInputSection">

                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Country </label>
                                                        <input type='text'
                                                            disabled={true}
                                                            value={registeredCountry}
                                                            onChange={(e) => setRegisteredCountry(e.target.value)}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                    <div>
                                                        <label className='add-facility-modal-label'>PIN Code </label>
                                                        <input type='text'
                                                            disabled={true}
                                                            value={registeredPostalCode}
                                                            onChange={(e) => setRegisteredPostalCode(e.target.value)}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <hr></hr>
                                        {(viewClicked || editClicked) && (
                                            <div>
                                                <h6 style={{ fontWeight: "bold" }}>Contact Information</h6>
                                                <div className="infoBodyInputs">
                                                    <div className="table_container_commercial_head">
                                                        <TableComponent
                                                            headers={[{
                                                                name: "Contract Number",
                                                                type: "text",
                                                                key: "contract_number",
                                                                sort: true
                                                            }, {
                                                                name: "Contract Name",
                                                                type: "text",
                                                                key: "contract_name",
                                                                sort: true
                                                            }, {
                                                                name: "Type",
                                                                type: "text",
                                                                key: "contact_type",
                                                                sort: true
                                                            }, {
                                                                name: "Contact Name",
                                                                type: "text",
                                                                key: "name",
                                                                sort: true
                                                            }, {
                                                                name: "Email",
                                                                type: "text",
                                                                key: "email",
                                                                sort: true
                                                            }, {
                                                                name: "Phone Number",
                                                                type: "text",
                                                                key: "phone_number",
                                                                sort: true
                                                            }
                                                            ]}
                                                            data={listOfContacts}

                                                        />

                                                    </div>
                                                </div>
                                            </div>)}


                                    </div>
                                </Tab>
                                {/* {(viewClicked || editClicked) && (
                                    <Tab eventKey="2" title="Users"
                                        className="assetTabs"  >
                                        <div className="infoBody">
                                            {customerUsersList?.length === 0 && (
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                                                    No Users Available
                                                </div>
                                            )}
                                            {customerUsersList?.map((customer, index) => (
                                                <div>

                                                    <div className="infoBodyInputs">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <h6 style={{ fontWeight: "bold" }}>User {index + 1}</h6>

                                                        </div>
                                                        <div className="responsiveInputSection">

                                                            <div >
                                                                <label className='add-facility-modal-label'>Full Name </label>
                                                                <input type='text'
                                                                    disabled={true}
                                                                    value={customer?.name}
                                                                    className='form-control responsive-add-facility-input-fields' />

                                                            </div>
                                                            <div >
                                                                <label className='add-facility-modal-label'>Username </label>
                                                                <input type='text'
                                                                    disabled={true}
                                                                    value={customer?.username}
                                                                    className='form-control responsive-add-facility-input-fields' />

                                                            </div>
                                                            <div >
                                                                <label className='add-facility-modal-label'>Email </label>
                                                                <input type='text'
                                                                    disabled={true}
                                                                    value={customer?.email}
                                                                    className='form-control responsive-add-facility-input-fields' />

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="responsiveInputSection">
                                                        <div >
                                                            <label className='add-facility-modal-label'
                                                            >Phone Number </label>
                                                            <PhoneInput
                                                                country={'in'}
                                                                value={customer?.phone_number}
                                                                disabled={true}
                                                                inputStyle={{ width: '250px', height: '37.33px', borderRadius: '5px', border: '1px solid #dee2e6' }}

                                                            />

                                                        </div>
                                                        <div >
                                                            <label className='add-facility-modal-label'
                                                            >Group </label>
                                                            <input type='text'
                                                                disabled={true}
                                                                value={customer?.group}
                                                                className='form-control responsive-add-facility-input-fields' />
                                                        </div>
                                                    </div>
                                                    <hr></hr>
                                                </div>
                                            ))}
                                        </div>
                                    </Tab>
                                )} */}
                            </Tabs>
                        </div>
                        <div style={{ marginTop: "20px", }}>
                            {
                                activeTab === '1' && (
                                    <div style={{ display: "flex", justifyContent: "end", }}>
                                        <button className="infoNextBtn" style={{ marginLeft: "30px", color: "white" }} onClick={() => {
                                            editClicked ? handleClose() : backFunction();
                                        }}>Close</button>
                                        {viewClicked || editClicked ?
                                            <button className="infoNextBtn" style={{ marginLeft: "30px", color: "white" }} onClick={() => {
                                                setActiveTab('2')
                                            }}>Next</button>
                                            : <button className="infoNextBtn" style={{ marginLeft: "30px", color: "white" }} onClick={() => {
                                                handleSaveClicked()
                                            }}
                                                disabled={gstNumber === '' || !isValidGstNumber || companyName === '' || panName === '' || registeredStreetAddress === '' || registeredStreetAddressLane2 === '' || registeredCity === '' || registeredStateProvince === '' || registeredCountry === '' || registeredPostalCode === ''}
                                            >Submit</button>
                                        }
                                    </div>
                                )
                            }
                            {
                                activeTab === '2' && (
                                    <div style={{ display: "flex", justifyContent: "end", }}>
                                        <button className="infoNextBtn" style={{ marginLeft: "30px", color: "white" }} onClick={() => {
                                            editClicked ? handleClose() : backFunction();
                                        }}>Close</button>
                                        <button className="infoNextBtn" style={{ marginLeft: "30px", color: "white" }} onClick={() => {
                                            setActiveTab('1')
                                        }}>Back</button>

                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            }
            {isLoading && <FormLoader />}
            <Footer />

        </>
    )
}